import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store';
// import basis from './modules/basis';
// import elevator from './modules/elevator';
// import jobmangement from './modules/jobmangement'
// import sysmanagement from './modules/sysmanagement'
import { Message } from 'element-ui';

Vue.use(Router)

const router = new Router({
    routes: [{
            path: '/',
            redirect: '/index'
        },
        {
            name: 'index',
            path: '/index',
            redirect: 'home',
            component: () =>
                import ('@/page/home/_res'),
            children: [
                //主页
                {
                    name: 'home',
                    path: '/home',
                    meta: {
                        code: '22A0'
                    },
                    component: () =>
                        import ('@/page/home/home'),
                },
                // ...basis, ...jobmangement, ...sysmanagement, ...elevator
            ]
        },
        { path: '/auth/login', name: 'login', component: () =>
                import ( /*webpackChunkName:"login"*/ "@/page/auth/login") },
        { path: '/auth/register', name: 'register', component: () =>
                import ( /*webpackChunkName:"register"*/ "@/page/auth/register") },
    ]
})
router.beforeEach(async(to, from, next) => {
    //判断是否登录且非跳转登录模块
    if (!store.getters.token && to.name !== 'login' && to.name !== 'register') {
        //储存跳转登陆前模块
        store.commit('UPDATE_BEFORE_ROUTERPATH', to.path);
        next({ name: 'login' });
        return false;
    }

    if (to.path === '/' || to.path === '/index' || to.name === 'login' || to.name === 'register') {
        next();
        return false;
    }
    //判断有无权限对象
    if (!store.getters.permission) {
        //获取权限
        await store.dispatch('updatedPermission');
    }
    //无权限
    if (!store.getters.permission[to.meta['code']]) {
        Message.error('很抱歉，您要访问的页面不存在！');
        next({ name: 'home' });
        return false;
    }

    if (to.path === '/home/eportsrMangement') {
        Message.error('该模块暂未开放');
        next(false);
        return false;
    }

    store.dispatch('updateDirect', to.path);
    next();
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js